"use client";
import React, { useEffect, useState } from "react"; // Add useState here
import { Link } from 'react-router-dom'; // Use react-router-dom for routing.
import EventDetailsImg1 from '../../assets/images/resources/event-details-img-box-img-1.jpg'
import EventDetailsImg3 from '../../assets/images/resources/event-details-img-1.jpg'
import { dbFB } from '../../Firebase';
import { doc, getDoc } from 'firebase/firestore/lite';

export default function Home({ eventoId }) {
  const [eventos, setEventos] = useState([]);
  const [activeTab, setActiveTab] = useState("tabEvento");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  async function fetchEvento() {
      try {
        const eventoRef = doc(dbFB, 'eventos', eventoId);
        const eventoSnap = await getDoc(eventoRef);
        if (eventoSnap.exists()) {
          const eventoData = { id: eventoSnap.id, ...eventoSnap.data() };
          if (eventoData.premium === 3 && eventoData.fechahorafinal.toDate() >= new Date()) {
            setEventos([eventoData]);
          } else {
            setEventos([]); // No cumple la condición
          }
        } else {
          setEventos([]);
        }
      } catch (error) {
        console.error('Error al obtener evento:', error);
      } finally {
        setLoading(false);
      }
    }

    fetchEvento();
  }, [eventoId]);

  if (loading) return <p>Cargando evento...</p>;
  if (eventos.length === 0) return <p>No se encontró el evento.</p>;

  const tabs = [
    {
      id: "tabEvento",
      year: "Evento",
      content: (
        <div className="event-details__tab-content-box">
          <ul className="event-details__meta list-unstyled">
            <li>
              <p>
                <span className="icon-clock"></span>
                {(eventos[0].direccion || "Dirección no disponible").replace(/<br\s*\/?>/gi, ' ')}
              </p>
            </li>
            <li>
              <p>
                <span className="icon-pin"></span>
                {
                    eventos[0].fechahora.toDate().toLocaleDateString('es-ES', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    })
                }    
                <span> - </span> 
                {
                    eventos[0].fechahora.toDate().toLocaleTimeString('es-EC', {
                        hour: '2-digit',
                        minute: '2-digit'
                    })
                }
              </p>
            </li>
          </ul>
          <h3 className="event-details__title-1">
            {eventos[0].titulo || 'Título no disponible'} <br/> {eventos[0].subtitulo || 'Subtitulo no disponible'} 
          </h3>
          <p className="event-details__text-1">
            {(eventos[0].descripcion || 'Descripción no disponible').replace(/<br\s*\/?>/gi, ' ')}
          </p>
          <p className="event-details__text-2">
            {eventos[0].detalleTabEvento[0] || ''}
          </p>
          <div className="event-details__img-box">
            <div className="row">
              {eventos[0].detalleTabEvento
              .slice(3)
              .map((imgSrc, idx) => (
                <div className="col-xl-6" key={'img-' + idx}>
                  <div className="event-details__img-box-img">
                    <img
                      src={imgSrc || EventDetailsImg1}
                      alt={`Imagen evento ${idx + 1}`}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
          <p className="event-details__text-3">
            {eventos[0].detalleTabEvento[1] || ''}
          </p>
          <p className="event-details__text-4">
            {eventos[0].detalleTabEvento[2] || ''}
          </p>
        </div>
      ),
    },
    {
      id: "tabArtistas",
      year: "Artistas",
      content: (
        <div className="event-details__tab-content-box">
          <ul className="event-details__meta list-unstyled">
          </ul>
          <h3 className="event-details__title-1">
            Invitados
          </h3>
          <p className="event-details__text-1">
            {eventos[0].detalleTabArtistas[0] || 'Descripción no disponible'}
          </p>
          <p className="event-details__text-2">
            {eventos[0].detalleTabArtistas[1] || ''}
          </p>
          <div className="event-details__img-box">
            <div className="row">
              {eventos[0].detalleTabArtistas
              .slice(4)
              .map((imgSrc, idx) => (
                <div className="col-xl-6" key={'img-' + idx}>
                  <div className="event-details__img-box-img">
                    <img
                      src={imgSrc || EventDetailsImg1}
                      alt={`Imagen evento ${idx + 1}`}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
          <p className="event-details__text-3">
            {eventos[0].detalleTabArtistas[2] || ''}
          </p>
          <p className="event-details__text-4">
            {eventos[0].detalleTabArtistas[3] || ''}
          </p>
        </div>
      ),
    },
    {
      id: "tabLugar",
      year: "Lugar",
      content: (
        <div className="event-details__tab-content-box">
          <ul className="event-details__meta list-unstyled">
          </ul>
          <h3 className="event-details__title-1">
            {eventos[0].lugar || 'Lugar no disponible'}
          </h3>
          <p className="event-details__text-1">
            {eventos[0].detalleTabLugar[0] || 'Descripción no disponible'}
          </p>
          <p className="event-details__text-2">
            {eventos[0].detalleTabLugar[1] || ''}
          </p>
          <div className="event-details__img-box">
            <div className="row">
              {eventos[0].detalleTabLugar
              .slice(4)
              .map((imgSrc, idx) => (
                <div className="col-xl-6" key={'img-' + idx}>
                  <div className="event-details__img-box-img">
                    <img
                      src={imgSrc || EventDetailsImg1}
                      alt={`Imagen evento ${idx + 1}`}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
          <p className="event-details__text-3">
            {eventos[0].detalleTabLugar[2] || ''}
          </p>
          <p className="event-details__text-4">
            {eventos[0].detalleTabLugar[3] || ''}
          </p>
        </div>
      ),
    },
    {
      id: "tabVideos",
      year: "Videos",
      content: (
        <div className="event-details__tab-content-box">
          <ul className="event-details__meta list-unstyled">
          </ul>
          <h3 className="event-details__title-1">
            Videoteca
          </h3>
          <p className="event-details__text-1">
          </p>
          <p className="event-details__text-2">
          </p>
          <div className="event-details__img-box">
            <div className="row">
              {eventos[0].videos
              .slice(0)
              .map((imgSrc, idx) => (
                <div className="col-xl-6" key={'img-' + idx}>
                  <div className="event-details__img-box-img">
                    <video src={imgSrc} width="400" height="450" controls></video>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <p className="event-details__text-3">
          </p>
          <p className="event-details__text-4">
          </p>
        </div>
      ),
    }
  ];

  return (
    <>
      
        {/*Blog Details Start*/}
        <section className="event-details">
          <div className="container">
            <div className="row">
              <div className="col-xl-8 col-lg-7">
                <div className="event-details__left">
                  <div className="event-details__img">
                    <img
                      src={eventos[0].imagenPremium3 || EventDetailsImg3}
                      alt=""
                    />
                  </div>
                  <div className="event-details__main-tab-box tabs-box">
                    <ul className="tab-buttons clearfix list-unstyled">
                      {tabs.map((tab) => (
                        <li
                          key={tab.id}
                          data-tab={`#${tab.id}`}
                          className={`tab-btn ${
                            activeTab === tab.id ? "active-btn" : ""
                          }`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          <p>{tab.year}</p>
                        </li>
                      ))}
                    </ul>
                    <div className="tabs-content">
                      {tabs.map((tab) => (
                        <div
                          key={tab.id}
                          className={`tab ${
                            activeTab === tab.id ? "active-tab" : ""
                          }`}
                          id={tab.id}
                        >
                          {tab.content}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-5">
                <div className="event-details__right">
                  <div className="event-details__speakers">
                    <h3 className="event-details__speakers-title">Artistas</h3>
                    <p className="event-details__speakers-sub-title">
                    </p>
                    <p className="event-details__speakers-text">
                      {eventos[0].artistas || 'Artistas no disponible'}
                    </p>
                  </div>
                  <div className="event-details__ticket">
                    <h3 className="event-details__ticket-title">
                      No tienes tu reserva?
                    </h3>
                    <p className="event-details__ticket-sub-title">
                      Contáctanos
                    </p>
                    <div className="event-details__ticket-icon">
                      <span className="icon-call"></span>
                    </div>
                    <p className="event-details__ticket-sub-title-2">
                      A nuestro servicio ágil
                    </p>
                    <h3 className="event-details__ticket-number">
                      <Link to={'tel:' + eventos[0].contactocell}>{eventos[0].contactocell}</Link>
                      <br />
                      <Link to={'tel:' + eventos[0].contactotel}>{eventos[0].contactotel}</Link>
                    </h3>
                  </div>
                  <div className="event-details__ticket-two">
                    <h3 className="event-details__ticket-two-title">
                      No tienes tu reserva?
                    </h3>
                    <p className="event-details__ticket-two-text">
                      Puedes reservar o comprar en nuestra enlace oficial del evento. Es fácil e intuitivo, no te lo puedes perder!
                    </p>
                    <div className="event-details__ticket-two-btn-box">
                      <Link
                        to={eventos[0].enlace} target="_blank" rel="noopener noreferrer"
                        className="event-details__ticket-two-btn thm-btn"
                      >
                        Información <span className="icon-arrow-right"></span>
                      </Link>
                    </div>
                  </div>
                  <div className="event-details__follow-us">
                    <h3 className="event-details__follow-us-title">
                      Síguenos en Redes
                    </h3>
                    <div className="event-details__follow-us-social">
                      {eventos[0].instagram && (
                          <a href={eventos[0].instagram} className="icon-social" target="_blank" rel="noopener noreferrer">
                              <span className="icon-instagram"> </span>
                          </a>
                      )}
                      {eventos[0].facebook && (
                          <a href={eventos[0].facebook} className="icon-social" target="_blank" rel="noopener noreferrer">
                              <span className="icon-facebook"> </span>
                          </a>
                      )}
                      {eventos[0].tiktok && (
                          <a href={eventos[0].tiktok} className="icon-social" target="_blank" rel="noopener noreferrer">
                              <span className="icon-star"> </span>
                          </a>
                      )}
                    </div>
                  </div>
                  <div className="event-details__location">
                    <h3 className="event-details__location-title">Cómo llegar</h3>
                    <iframe
                      src={eventos[0].ubicacion}
                      className="google-map__one"
                      allowFullScreen
                      title="Ubicación del evento"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*Blog Details End*/}
    </>
  );
}
